/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash ce13938d054e3cd1f28bf630019c57f0 */

import { ConcreteRequest } from "relay-runtime";
export type auth_refreshAuthTokenQueryVariables = {};
export type auth_refreshAuthTokenQueryResponse = {
    readonly viewer: {
        readonly session: {
            readonly token: string;
        };
    };
};
export type auth_refreshAuthTokenQuery = {
    readonly response: auth_refreshAuthTokenQueryResponse;
    readonly variables: auth_refreshAuthTokenQueryVariables;
};



/*
query auth_refreshAuthTokenQuery {
  viewer {
    session {
      token
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Viewer",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "session",
        "storageKey": null,
        "args": null,
        "concreteType": "Session",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "token",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "auth_refreshAuthTokenQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "auth_refreshAuthTokenQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "auth_refreshAuthTokenQuery",
    "id": null,
    "text": "query auth_refreshAuthTokenQuery {\n  viewer {\n    session {\n      token\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '059caf0d327f43341211f534f9424f00';
export default node;
